module.exports = __webpack_public_path__ + "static/media/signage-outdoor-img56.d4757710.jpg";